export default function navSec() {

    $('.btn-menu').on('click', function () {
        $('body').toggleClass('menu-open');
    });
}